import React, { useState } from "react";
import './DiaporamaAnneDelrez.scss';
import Conf from 'utils/Conf';
import Fullscreen from 'components/Fullscreen';

import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
SwiperCore.use([Navigation, Autoplay]);

function DiaporamaAnneDelrez({images, onLegendChange}) {
  const [index, setIndex ]= useState(0);
  const handleSlideChange=(swiper)=>{
    setIndex(swiper.activeIndex);
    onLegendChange && onLegendChange(images[swiper.activeIndex].directus_files_id.title)
  }
  return <div className="images-player">
    <Swiper
     navigation
    autoplay={{
      delay:10000,
      disableOnInteraction:false
    }}
    speed={1000}
    onSlideChange={handleSlideChange}
    onSwiper={handleSlideChange}
    >
      {images.map((img,i)=>{
          return <SwiperSlide key={img.directus_files_id.id}>
            <img alt={img.directus_files_id.title} src={`${Conf.apiUrl}/assets/${img.directus_files_id.id}?key=16-9`}/>
          </SwiperSlide>;
      })}
    </Swiper>
    <span className="images-player-compteur">{index+1} / {images.length}</span>
    <Fullscreen/>
  </div>;
}

export default DiaporamaAnneDelrez;
